import { createFileRoute } from '@tanstack/react-router';
import { BusinessPageContent } from '~/app/business';
import { businessFaq } from '~/content/business';
import { getTestimonials } from '~/lib/payload';
import { faqPageJsonLd, pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

/**
 * Arabic business page.
 *
 * Keeps the English route's loader: the testimonial quotes come from Payload and
 * exist in English only. Customer quotes are deliberately *not* translated — they
 * are attributed statements, and rewriting them in Arabic would misrepresent what
 * the customer actually said. Only the section heading around them is localized.
 */
export const Route = createFileRoute('/ar/business')({
  loader: () => getTestimonials({ data: 'business' }),
  head: () => {
    const head = pageHeadMeta({
      title: 'حسابات nsave للشركات بالدولار واليورو والإسترليني',
      description:
        'حساب دولي لشركتك: استقبل مدفوعات عملائك بالدولار واليورو والإسترليني، وحوّل بين عملاتك، وادفع لفريقك وفواتيرك من منصة واحدة.',
      path: '/ar/business',
      inlineStyles: [heroCss],
    });
    return { ...head, scripts: [...head.scripts, faqPageJsonLd(businessFaq)] };
  },
  component: ArabicBusinessPage,
});

function ArabicBusinessPage() {
  return <BusinessPageContent quotes={Route.useLoaderData()} />;
}
